import './Details.scss';
import type { ReactNode } from 'react';

import { DetailsHeader, type DetailsHeaderProps } from './DetailsHeader';

export type DetailsPaneProps = DetailsHeaderProps & { readonly children?: ReactNode };

/** The frame of a read-only details pane: the header line, then a scrolling body. */
export const DetailsPane = ({ children, ...header }: DetailsPaneProps) => (
  <div className="details-pane">
    <DetailsHeader {...header} />
    <div className="details-pane__body">{children}</div>
  </div>
);
